<template>
  <div class="list-view">
    <div class="list-header hide-on-pad-flex">
      <div class="left"><slot name="header-left"></slot></div>
      <div class="center"><slot name="header-center"></slot></div>
      <div class="right"><slot name="header-right"></slot></div>
    </div>
    <div class="list-container">
      <slot name="list-container"></slot>
    </div>
    <div class="list-footer">
      <div class="loading-layout" v-show="showLoading">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div class="end-text" v-show="!showLoading">
        {{ endText ? endText : $t('list_view.no_more') }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'list-view',
    props: {
      showLoading: {
        type: Boolean,
        default: true
      },
      endText: {
        type: String,
        default: ''
      }
    },
    data() {
      return {

      }
    },
    mounted() {
      this.$nextTick(() => {
        console.log('监听');
        // 这边一定要用外部函数给addEventListener，这样removeEventListener才可以移除事件
        document.addEventListener('scroll',this.handleScroll)
      })
    },
    destroyed() {
      console.log('list view destroyed');
      document.removeEventListener('scroll',this.handleScroll,false);
    },
    methods: {
      handleScroll() {
        const footer = document.querySelector('.c-footer');
        const footerHeight = parseInt(window.getComputedStyle(footer,null).getPropertyValue('height').replace('px',''));
        const htmlH = document.documentElement.clientHeight || document.body.clientHeight; // 网页高度
        const scrollH = (document.documentElement.scrollHeight || document.body.scrollHeight) // 总共高度
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop //目前滚动到的高度
        let onBottom = scrollH - htmlH - footerHeight - 50;
        if(scrollTop >= onBottom) {
          console.log('到底啦～');
          this.$emit('scrollOnBottom');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.list-view {
  .list-header {
    display: flex;
    background: #F0F0F0;
    border-top: 1px solid #A9A9A9;
    border-bottom: 1px solid #A9A9A9;
    .left,.center,.right {
      flex: 1;
      text-align: center;
      padding: 8px 20px;
    }
    .right {
      text-align: right;
    }
  }
  .list-footer {
    display: flex;
    width: 100%;
    height: 100px;
    justify-content: center;
    align-items: center;
  }
  .end-text {

  }
  .loading-layout {
    display: flex;
    width: 100%;
    height: 100px;
    justify-content: center;
    align-items: center;
    .dot {
      position: relative;
      width: 12px;
      height: 12px;
      margin: 4px;
      border-radius: 50%;

      &::before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background: inherit;
        border-radius: inherit;
        animation: wave 1.5s ease-out infinite;
      }

      &:nth-child(1) {
        background: #A94596;

        &::before {
          animation-delay: 1 * 0.2s;
        }
      }
      &:nth-child(2) {
        background: #B64784;

        &::before {
          animation-delay: 2 * 0.2s;
        }
      }
      &:nth-child(3) {
        background: #C4416B;

        &::before {
          animation-delay: 3 * 0.2s;
        }
      }
      &:nth-child(4) {
        background: #E55F70;

        &::before {
          animation-delay: 4 * 0.2s;
        }
      }
      &:nth-child(5) {
        background: #F88F55;

        &::before {
          animation-delay: 5 * 0.2s;
        }
      }
    }
  }

  @keyframes wave {
    50%,
    75% {
      transform: scale(2.5);
    }

    80%,
    100% {
      opacity: 0;
    }
  }

}
</style>